export const menuItems = [
  /*
  {
    label: "common.account-profile",
    isTitle: true,
  },
  {
    label: "account.my-profile-information",
    icon: "mdi mdi-account",
    link: "/account",
  },
  {
    label: "workspace.my",
    icon: "mdi mdi-hexagon-multiple-outline",
    link: "/workspace",
  },
  */
];

export const workspaceMenuItems = [
  // {
  //   isLayout: true,
  // },
  // {
  //   label: "organization.plural",
  //   icon: "mdi mdi-office-building",
  //   link: "/workspace/organizations",
  // },
  // {
  //   label: "workspace.members",
  //   icon: "mdi mdi-account-group",
  //   link: "/workspace/members",
  // },
  {
    id: "system-default",
    label: "workspace-defaults.text",
    isTitle: true,
  },

  {
    id: "1.1",
    label: "system-defaults.template-management.text",
    icon: "bx-receipt",
    link: "/workspace/template-edit",
  },
  {
    id: 1,
    label: "common.library",
    isTitle: true,
  },
  {
    id: 2,
    label: "common.library",
    icon: "bx-data",
    subItems: [
      // BEGIN : Entity Pages
      {
        id: "unit",
        label: "unit.text",
        icon: "mdi mdi-office-building",
        link: "/workspace/library/unit",
      },

      {
        id: 2.5,
        parentId: 2,
        label: "data.text",
        icon: "bx-git-repo-forked",
        subItems: [
          {
            id: 3,
            label: "data.text",
            link: "/workspace/library/data",
            parentId: 2.5,
          },
          {
            id: 4,
            label: "data-category.text",
            link: "/workspace/library/data-category",
            parentId: 2.5,
          },
        ],
      },
      {
        id: "datasubject-parent",
        parentId: 2,
        label: "datasubject.text",
        icon: "bx-git-repo-forked",
        subItems: [
          {
            id: "datasubject",
            label: "datasubject.text",
            link: "/workspace/library/datasubject",
            parentId: "datasubject-parent",
          },
          {
            id: "datasubject-category",
            label: "datasubject-category.text",
            link: "/workspace/library/datasubject-category",
            parentId: "datasubject-parent",
          },
          {
            id: "datasubject-right",
            label: "datasubject-right.text",
            link: "/workspace/library/datasubject-right",
            parentId: "datasubject-parent",
          },
        ],
      },
      {
        id: "data-breach",
        label: "data-breach.text",
        subItems: [
          {
            id: "abroad-third-party",
            label: "abroad-third-party.text",
            link: "/workspace/library/abroad-third-party",
          },
          {
            id: "domestic-third-party",
            label: "domestic-third-party.text",
            link: "/workspace/library/domestic-third-party",
          },
          {
            id: "notification-type",
            label: "notification-type.text",
            link: "/workspace/library/notification-type",
          },
          {
            id: "possible-effect",
            label: "possible-effect.text",
            link: "/workspace/library/possible-effect",
          },
          {
            id: "processing-adjective",
            label: "processing-adjective.text",
            link: "/workspace/library/processing-adjective",
          },
          {
            id: "source-and-type",
            label: "source-and-type.text",
            link: "/workspace/library/source-and-type",
          },
        ],
      },
      {
        id: "processing-transfering",
        label: "processing-transfering.text",
        subItems: [
          {
            id: "purpose",
            label: "processing-transfering.purpose.text",
            link: "/workspace/library/purpose",
            parentId: "processing-transfering",
          },
          {
            id: "legal-reason",
            label: "processing-transfering.legal-reason.text",
            link: "/workspace/library/legal-reason",
            parentId: "processing-transfering",
          },
          {
            id: "legitimate-interest",
            label: "processing-transfering.legitimate-interest.text",
            link: "/workspace/library/legitimate-interest",
            parentId: "processing-transfering",
          },
        ],
      },
      {
        id: 2.2,
        parentId: 2,
        label: "department.text",
        subItems: [
          {
            id: 5,
            label: "department.text",
            link: "/workspace/library/department",
            parentId: 2.2,
          },
          {
            id: 6,
            label: "department-category.text",
            link: "/workspace/library/department-category",
            parentId: 2.2,
          },
        ],
      },
      {
        id: 2.3,
        label: "process.text",
        subItems: [
          {
            id: 6,
            label: "process.text",
            link: "/workspace/library/process",
            parentId: 2.3,
          },
          {
            id: 7,
            label: "process-category.text",
            link: "/workspace/library/process-category",
            parentId: 2.3,
          },
        ],
      },
      {
        id: 2.4,
        label: "datasource.text",
        subItems: [
          {
            id: 8,
            label: "datasource.text",
            link: "/workspace/library/data-source",
          },
        ],
      },
      {
        id: 2.6,
        label: "storage-environments.text",
        subItems: [
          {
            id: 11,
            label: "physical-storage.text",
            link: "/workspace/library/physical-storage",
          },
          {
            id: 12,
            label: "physical-storage-category.text",
            link: "/workspace/library/physical-storage-category",
          },
          {
            id: 9,
            label: "electronic-storage.text",
            link: "/workspace/library/electronic-storage",
          },
          {
            id: 10,
            label: "electronic-storage-category.text",
            link: "/workspace/library/electronic-storage-category",
          },
          {
            id: 13,
            label: "disposal-method.text",
            link: "/workspace/library/disposal-method",
          },
        ],
      },
      {
        id: 2.99,
        label: "archive-environments.text",
        subItems: [
          {
            id: 14,
            label: "physical-archive.text",
            link: "/workspace/library/physical-archive",
          },
          {
            id: 15,
            label: "physical-archive-category.text",
            link: "/workspace/library/physical-archive-category",
          },
          {
            id: 16,
            label: "electronic-archive.text",
            link: "/workspace/library/electronic-archive",
          },
          {
            id: 17,
            label: "electronic-archive-category.text",
            link: "/workspace/library/electronic-archive-category",
          },
        ],
      },
      {
        id: 2.7,
        label: "accessing-persons.text",
        subItems: [
          {
            id: 12,
            label: "accessing-persons.text",
            link: "/workspace/library/accessor",
          },
        ],
      },
      {
        id: "access-restriction",
        label: "access-restriction.text",
        subItems: [
          {
            id: 1,
            label: "access-restriction.text",
            link: "/workspace/library/access-restriction",
          },
        ],
      },

      {
        id: "policy-parent",
        label: "policy.text",
        subItems: [
          {
            id: "policy",
            label: "policy.text",
            link: "/workspace/library/policy",
          },
          {
            id: "policy-group",
            label: "policy-group.text",
            link: "/workspace/library/policy-group",
          },
        ],
      },
      {
        id: 2.5,
        label: "collect-method.text",
        subItems: [
          {
            id: 1,
            label: "direct-collect-method.text",
            link: "/workspace/library/direct-collect-method",
            parentId: 2.5,
          },
          {
            id: 2,
            label: "other-collect-method.text",
            link: "/workspace/library/other-collect-method",
            parentId: 2.5,
          },
        ],
      },
      {
        id: 2.9,
        label: "receiver-group.text",
        subItems: [
          {
            id: 1,
            label: "receiver-group.text",
            link: "/workspace/library/receiver-group",
          },
        ],
      },
      {
        id: "transfering",
        label: "transfering.text",
        subItems: [
          {
            id: "transfering-method",
            label: "transfering.method.text",
            link: "/workspace/library/transfering-method",
            parentId: "transfering",
          },
          {
            id: "transfering-prevention",
            label: "transfering.prevention.text",
            link: "/workspace/library/transfering-prevention",
            parentId: "transfering",
          },
        ],
      },
      {
        id: 2.6,
        label: "agreement-type.text",
        subItems: [
          {
            id: 1,
            label: "agreement-type.text",
            link: "/workspace/library/agreement-type",
          },
        ],
      },
      {
        id: "risk",
        label: "risk.text",
        subItems: [
          {
            id: "risk-definition",
            label: "risk.definition.text",
            link: "/workspace/library/risk-definition",
          },
          {
            id: "risk-threat-definition",
            label: "risk.threat-definition.text",
            link: "/workspace/library/risk-threat-definition",
          },
          {
            id: "risk-weakness-definition",
            label: "risk.weakness-definition.text",
            link: "/workspace/library/risk-weakness-definition",
          },
          {
            id: "risk-applied-control",
            label: "risk.applied-control.text",
            link: "/workspace/library/risk-applied-control",
          },
        ],
      },
      {
        id: "question-set",
        label: "question-set.plural",
        subItems: [
          {
            id: "question-set",
            label: "question-set.plural",
            link: "/workspace/library/question-set",
          },
          {
            id: "question",
            label: "question.text",
            link: "/workspace/library/question",
          },
        ],
      },
      {
        id: "legal-document-template",
        label: "legal-document-template.text",
        subItems: [
          {
            id: "legal-document-template",
            label: "legal-document-template.text",
            link: "/workspace/legal-document-template",
          },
        ],
      },
      {
        id: "tasks",
        label: "task-menu.text",
        subItems: [
          {
            id: "task-category",
            label: "task-menu.task-category.text",
            link: "/workspace/library/task-category",
          },
        ],
      },

      {
        id: "application",
        parentId: 2,
        label: "application.text",
        subItems: [
          {
            id: 3,
            label: "application.category.text",
            link: "/workspace/library/application-category",
            parentId: "application",
          },
        ],
      },
      {
        id: "country",
        parentId: 2,
        label: "country.text",
        subItems: [
          {
            id: 3,
            label: "country.country-safe-mapping.text",
            link: "/workspace/library/safe-country-map",
            parentId: "country",
          },
        ],
      },

      // END : Entity Pages
    ],
  },
];
